import { useDeepEffect } from '@crossnokaye/ux-common';

import { useReadingsSubscription } from '@/hooks/query-hooks/gaia-api/use-readings-subscription';
import { SubscriptionIdentifier } from '@/hooks/query-hooks/gaia-api/use-subscription-base';
import { useCurrentFacility } from '@/hooks/use-current-facility';

/**
 * Hook for subscribing to readings data for equipment details.
 *
 * Automatically extracts reading references from equipment response data and subscribes
 * to them for real-time updates. Handles both display readings and component readings
 * used in action component states.
 *
 * @param equipmentResponse - The equipment details response containing reading references
 */
export const useSubscribeEBReadings = (readingsIdentifiers: SubscriptionIdentifier[]) => {
  const { agentId } = useCurrentFacility();

  const { subscribe: subscribeReadings } = useReadingsSubscription({ agentId });

  useDeepEffect(() => {
    if (readingsIdentifiers?.length) {
      subscribeReadings(readingsIdentifiers);
    }
  }, [subscribeReadings, readingsIdentifiers]);
};
